<template>
  <v-simple-table>
    <tbody>
      <Row title="Name"                   :text="customer.name" bold="true" v-if="customer.name" />
      <Row title="Telephone"              :msisdn="customer.msisdn" />
      <Row title="Identity"               :text="customer.demographic.identity.number"  />
      <Row title="Married"                :status="(customer.demographic.married  ? 'Yes' :  'No')"          v-if="customer.demographic" />
      <Row title="Gender"                 :gender="customer.demographic.gender"                              v-if="customer.demographic" />
      <Row title="Age"                    :number="customer.demographic.age"                                 v-if="customer.demographic" />


      <Row title="Income"                 :currency="parseInt(customer.economic.icome)"                      v-if="customer.economic && customer.economic.icome"           />
      <Row title="Net Pay"                :currency="parseInt(customer.economic.nettPay)"                    v-if="customer.economic && customer.economic.nettPay"         />
      <Row title="Adjusted Net Income"    :currency="parseInt(customer.economic.adjustedNettPay)"            v-if="customer.economic && customer.economic.adjustedNettPay" />

      <Row title="Employer"               :text="customer.employer.name"                                     v-if="customer.employer && customer.employer.name"          />
      <Row title="Department"             :text="customer.employer.department"                               v-if="customer.employer && customer.employer.department"    />
      <Row title="" >
        <v-btn color="primary" dense small :to="{ query: { uuid: uuid }, name: 'CreateContact' }">
          <v-icon small left>mdi-account-edit</v-icon>
          Edit
        </v-btn>
      </Row>
    </tbody>
  </v-simple-table>
</template>

<script>
import Row from "@/components/Row";

export default {

  components: { Row },

  props: {
    customer: {
      type: Object,
      required: true,
    }
  },


  computed: {
    uuid() { return this.customer.uuid; },
  },

}
</script>
